module.exports = __webpack_public_path__ + "img/东成电锤2.63fcf8de.jpg";